var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_735_3481)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_735_3481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.875 9.4425L11.3475 11.49C11.4225 11.8125 11.07 12.0675 10.785 11.895L9 10.815L7.2075 11.895C6.9225 12.0675 6.57 11.8125 6.645 11.49L7.125 9.45L5.55 8.0925C5.295 7.875 5.43 7.4625 5.76 7.4325L7.845 7.2525L8.655 5.3325C8.7825 5.025 9.2175 5.025 9.345 5.3325L10.155 7.245L12.24 7.425C12.57 7.455 12.705 7.8675 12.45 8.085L10.875 9.4425ZM3.1425 3.3525C2.6025 3.5925 2.25 4.1325 2.25 4.725V8.25C2.25 12.4125 5.13 16.305 9 17.25C12.87 16.305 15.75 12.4125 15.75 8.25V4.725C15.75 4.1325 15.3975 3.5925 14.8575 3.3525L9.6075 1.02C9.2175 0.8475 8.775 0.8475 8.3925 1.02L3.1425 3.3525Z",
    fill: "#FC4444"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_735_3481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_735_3481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.4af801265dbd3b24a407f4bea79cf3e2.svg";
export { ForwardRef as ReactComponent };